import type { Route } from "./+types/$locale.how-it-works";
import { buildSeoMeta } from "@/components/seo/meta";
import { RentalsInfoPage } from "@/features/support/routes/RentalsInfoPage";

/**
 * No loader: the how-it-works page renders fully static content (step list +
 * defaults), no client-side data fetching. The meta export emits SEO tags;
 * the component renders as before.
 */

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "How It Works — Renting Baby Equipment Made Simple",
        description:
            "Learn how renting baby equipment works: browse, checkout, pick up, enjoy, and return. Short-term rentals and monthly subscriptions available.",
        path: "/how-it-works",
        keywords:
            "how baby equipment rental works, rental process, stroller rental steps, monthly baby subscription",
        // TODO Phase 6: hydrate availableLocales from root loader manifest
        locale,
        availableLocales: [{ code: "en" }],
    });
}

export default function HowItWorksRoute() {
    return <RentalsInfoPage />;
}
